import ApiClient from '@package/services/src/ApiClient';
import Result, { EmptyResult } from '@package/services/src/Result';

import { GiftCardService } from './services';
import { DeleteGiftCardRequest, GiftCard, GiftCardApplied, GiftCardRequest, GetGiftCardsRequest } from './types';

class GiftCardApiService implements GiftCardService {
  public constructor(private readonly apiClient: ApiClient) {}

  public async getGiftCards(request?: GetGiftCardsRequest): Promise<Result<Array<GiftCard> | null>> {
    try {
      const res = await this.apiClient.get('/shoppingCart/giftCards', {
        credentials: request?.cookie ? 'include' : undefined,
        headers: request?.cookie ? { Cookie: request.cookie } : undefined,
      });
      const json: Array<GiftCard> = await res.json();

      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      return new Result(json || ([] as Array<GiftCard>));
    } catch (error) {
      console.error('Unable to get Gift Cards');
      return new Result(null);
    }
  }

  public async deleteGiftCard(request: DeleteGiftCardRequest): Promise<EmptyResult> {
    try {
      await this.apiClient.delete('/shoppingCart/giftCards', {
        body: { serialNumber: request.serialNumber },
      });

      return new EmptyResult();
    } catch (error) {
      console.error(`Unable to delete Gift Cards with serial number: ${request.serialNumber}`);
      return new EmptyResult();
    }
  }

  public async applyGiftCard(request: GiftCardRequest): Promise<Result<GiftCardApplied | undefined>> {
    const { giftCardCode, receiverLastName } = request;

    const res = await this.apiClient.post('/shoppingCart/giftCards', {
      body: {
        giftCardCode: giftCardCode.trim(),
        receiverLastName: receiverLastName.trim(),
      },
    });

    if (res.status === 200) {
      return new Result({ applied: true });
    }

    return new Result(undefined);
  }
}

export default GiftCardApiService;
